import { SET_ACCOUNT_TAB, SET_OVERVIEW_TAB } from "../actions/route";

export default function route(
  state = {
    accountTabIndex: 0,
    accountTabLabels: ["settings", "people"],
    overviewTabIndex: 0,
    overviewTabLabels: ["time", "accounts"]
  },
  action
) {
  switch (action.type) {
    case SET_ACCOUNT_TAB:
      return Object.assign({}, state, {
        accountTabIndex: action.index
      });

    case SET_OVERVIEW_TAB:
      return Object.assign({}, state, {
        overviewTabIndex: action.index
      });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/route.js